import React from 'react';
import './styles.css';

type RadioBoxProps = {
    label: string;
    name: string;
    value: string;
    checked: boolean;
    onChange: (value: string) => void;
};

export const RadioBox = ({ label, name, value, checked, onChange }: RadioBoxProps) => {
    return (
        <label className={`radio-box ${checked ? 'checked' : ''}`}>
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                onChange={() => onChange(value)}
            />
            <span className="custom-radio" />
            <span className="label-text">{label}</span>
        </label>
    );
};
